module.exports = __webpack_public_path__ + "media/images/cover/house-coin-e7553151a6bb798022d2e20e6f05235b.jpg";